import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import messageHandler from 'utils/messageHandler';

const mlSlice = createSlice({
  name: 'ml',
  initialState: {
    user: null,
    totalProperties: {
      properties_imported: 'Cargando..',
      properties_to_import: 'Cargando..'
    },
    loading: false,
    properties: [],
    statusSinchronized: {
      properties_imported: {
        ids: [],
        count: 0
      },
      properties_with_errors: {
        ids: [],
        count: 0
      }
    }
  },
  reducers: {
    setProperties: (state, { payload }) => {
      state.properties = payload;
    },
    setUser: (state, { payload }) => {
      state.user = payload;
      state.loading = false;
    },
    setTotalProperties: (state, { payload }) => {
      state.totalProperties = payload;
      state.loading = false;
    },
    setStatusSinchronized: (state, { payload }) => {
      state.statusSinchronized = payload;
    },
    request: state => {
      state.loading = true;
    },
    error: state => {
      state.loading = false;
    }
  }
});

export const {
  setUser,
  request,
  error,
  setProperties,
  setTotalProperties,
  setStatusSinchronized
} = mlSlice.actions;

export const getUrlML = () => async dispatch => {
  try {
    dispatch(request());

    const response = await axios.get(
      `${process.env.REACT_APP_SERVER}/mercado-libre/get-url`
    );

    return response;
  } catch (e) {
    messageHandler(
      'error',
      e?.response?.data?.message || 'Error al obtener la url de Mercado Libre'
    );
    dispatch(error());
    return { status: 400, message: 'Error al obtener la url de Mercado Libre' };
  }
};

export const sendCode = code => async dispatch => {
  try {
    dispatch(request());

    const response = await axios.get(
      `${process.env.REACT_APP_SERVER}/mercado-libre/callback?code=${code}`
    );

    dispatch(setUser(response.data));

    return response;
  } catch (e) {
    messageHandler('error', e.response.data.message);
    dispatch(error());
    return e.response.data.message;
  }
};

export const getUser = () => async dispatch => {
  try {
    dispatch(request());

    const response = await axios.get(
      `${process.env.REACT_APP_SERVER}/mercado-libre/get-user`
    );

    dispatch(setUser(response.data));

    return response;
  } catch (e) {
    // messageHandler('error', e.response.data.message);
    dispatch(error());
    return e.response.data.message;
  }
};

export const getUserMlByUserId = userId => async dispatch => {
  try {
    dispatch(request());
    const data = await axios.get(
      `${process.env.REACT_APP_SERVER}/mercado-libre/get-user-by-user-id/${userId}`
    );

    dispatch(setUser(data.data));

    return data;
  } catch (e) {
    // messageHandler('error', e.response.data.message);
    dispatch(setUser(null));
    dispatch(error());
    return e.response.data.message;
  }
};

export const syncProperties = () => async dispatch => {
  try {
    dispatch(request());

    const response = await axios.get(
      `${process.env.REACT_APP_SERVER}/mercado-libre/replace-properties`
    );

    dispatch(setStatusSinchronized(response.data));
  } catch (e) {
    messageHandler('error', e?.response?.data?.message);
    dispatch(error());
  }
};

export const connectedML = () => async dispatch => {
  try {
    dispatch(request());

    const response = await axios.get(
      `${process.env.REACT_APP_SERVER}/mercado-libre/connected`
    );

    dispatch(setUser(response.data));
  } catch (e) {
    messageHandler('error', e?.response?.data?.message);
    dispatch(error());
  }
};

export const singOut = () => async dispatch => {
  try {
    dispatch(request());

    await axios.get(`${process.env.REACT_APP_SERVER}/mercado-libre/sign-out`);

    dispatch(setUser(null));
  } catch (e) {
    messageHandler('error', e?.response?.data?.message);
    dispatch(error());
  }
};

export const getTotalProperties = () => async dispatch => {
  try {
    dispatch(request());

    const response = await axios.get(
      `${process.env.REACT_APP_SERVER}/mercado-libre/get-total-properties`
    );

    dispatch(setTotalProperties(response.data));
  } catch (e) {
    messageHandler('error', e?.response?.data?.message);
    dispatch(error());
  }
};

export default mlSlice.reducer;
